import { render, staticRenderFns } from "./response.vue?vue&type=template&id=c525ca9a&scoped=true"
import script from "./response.vue?vue&type=script&lang=js"
export * from "./response.vue?vue&type=script&lang=js"
import style0 from "./response.vue?vue&type=style&index=0&id=c525ca9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c525ca9a",
  null
  
)

export default component.exports